import { Pagination } from "../pagination";
import { Modifier } from "./modifier";
import { TableInTicketDetail } from "./table";
import { TicketDiscount } from "./discount";
import { TicketType } from "../constants/enum.pos";
import { MenuItemByGroupId } from "./item";

export class TicketDetail {
	id: number = null;
	displayId: string = null;
	numberOfGuests: number = null;
	status: string = null;
	tableInfo: string = null;
	tableAlias: string[] = null;
	tables: TableInTicketDetail[] = [];
	color: string = null;
	totalDiscountBill: number = null;
	changeAmount: number = null;
	totalPrice: number = null;
	totalPriceForDisplaying: number = null;
	totalPriceUsd: number = null;
	totalTax: number = null;
	subTotal: number = null;
	subToTalForDisplaying: number = null;
	serviceCharge: number = null;
	deliveryCharge: number = null;
	deliveryChargeDb: number = null;
	discountAmount: number = null;
	taxExcluded: boolean = false;
	isPaidInUsd: boolean = false;
	fxRateVndPerUsd: number = null;
	roundingVn: number = null;
	availableAmountForDiscount: number = null;
	items: TicketItem[] = [];
	couponDiscounts: TicketDiscount[] = [];
	discounts: TicketDiscount[] = [];
	owner: number = null;
	paymentType: string = null;
	paymentTypeDisplay: number = null;
	ticketType: string = null;
	ticketTypeChinese: string = null;
	invoiceAutoNumber: string = null;
	// totalDiscount: number = null;
	dueAmount: any = null;
	dueAmountUsd: any = null;
	tenderedAmount: any = null;
	// serviceFees: number = null;
	// subTotalExcludeDiscount: number = null;
	reviewTicketItemIds: number[] = [];
	createdAt: string = null;
	createdBy: string = null;
	deletedAt: string = null;
	deletedBy: string = null;
	updatedAt: string = null;
	updatedBy: string = null;
	closingDate: string = null;
	totalDiscount: number = null;
	concurrencyStamp: string = null;
	customerId: string = null;
	customerName: string = null;
	billPrinted?: number = null;
	totalVat8?: number = null;
	totalVat10?: number = null;
	// Invoice
	ticketInvoice: TicketInvoice = null;
	serviceChargeString: string = null;
	paymentTypeShort: string = null;
	paymentTypeArray: string[] = [];
}
export class ReplaceInvoice {
	ticketId?: string = null;
	CusEmail?: string = null;
}
export class TicketItem {
	id: number = 0; // Id indentity
	itemId: number = null;
	itemOrder: number = null;
	quantity: number = null;
	price: number = null;
	priceOrginal: number = null;
	discount: number = null;
	canDiscount: boolean = true;
	isSetMenu: boolean = false;
	isParentOfSetMenu: boolean = false;
	parentSetMenuKey: string = null;
	subTotal: number = null;
	name: string = null;
	status: string = null;
	menuGroupId: number = null;
	isPrintedToKitchen: boolean = false;
	tax: TicketItemTax = null;
	modifiers: Modifier[] = [];
	estimatedTaxAmountPerItem: number = null;
	modifierGroupIds: number[] = [];
	selected?: boolean = null;
	childSelected?: boolean = null;
	selectedDiscount?: boolean = null;
	hashKey?: string = null;
	// Set menu
	childMenuItems: TicketItem[] = [];
	isChildren: boolean = false;
	serviceCharge: number = 0;
	taxAmount: number = 0;
	menuItem: MenuItemByGroupId;
	totalPrice: number;
}

export class RequestItemForTransfer {
	ticketId: number = null;
	concurrencyStamp: string = null;
	item: TicketItem = null;
	tables: TableInTicketDetail = null;
}
export class RequestVoidItem {
	ticketId: number = null;
	concurrencyStamp: string = null;
	items: TicketItemVoid[] = [];
}

export class TicketItemVoid {
	id: number = null;
	voidQuantity: number = null;
	price: number = null;
	isPrintedToKitchen: boolean = false;
}

export class TicketItemTax {
	id: number = null;
	name: string = null;
	rate: number = null;
}
export class ActionForOrder {
	isAllowUpdateQuantity: boolean = false;
	isAllowDiscount: boolean = false;
	isAllowVoid: boolean = false;
	isAllowChangePrice: boolean = false;
	isAllowTransfer: boolean = false;
	isAllowDeleteItem: boolean = false;
}

export interface OrderCategory {
	id: number;
	name: string;
}
export interface OrderType {
	ticketType: TicketType;
	name: string;
	active?: boolean;
}
export interface OrderGroupItem {
	id: number;
	name: string;
	btnColor: string;
	textColor: string;
	hasChildGroup: boolean;
}
export interface RightPanelCategories extends Pagination {
	data: OrderCategory[];
}

export interface RequestCreateTicket {
	numberOfGuests: number;
	tableIds: number[];
	tableAlias: string;
	ticketType: string;
	totalDiscount: number;
	deliveryCharge: number;
	totalTax: number;
	taxId: number;
	subTotal: number;
	total: number;
	items: RequestItem[];
	concurrencyStamp: string;
}

export interface RequestItem {
	id: number;
	itemId: number;
	quantity: number;
	price: number;
	discount: number;
	itemOrder: number;
	modifiers: RequestModifier[];
	childMenuItems: TicketItem[];
	hashKey?: string;
}

export interface RequestModifier {
	id: number;
	modifierId: number;
	menuModifierGroupId: number;
	quantity: number;
	price: number;
}

export class RequestPayTicket {
	ticketId: number = null; // not nullable
	tenderedAmount: number = null; // not nullable
	isPaidInUsd: boolean = null; // not nullable
	paymentType: string = null; // PaymentType picked by Get Payment Type Api
	concurrencyStamp: string = null;
}

export class TicketInvoice {
	id: number = null;
	ticketId: string = null;
	fkey: string = null;
	pattern: string = null;
	serial: string = null;
	invoiceNumber: string = null;
	publishDate: string = null;
	publishCheck: number = null;
	cusCode: string = null;
	cusName: string = null;
	cusAddress: string = null;
	cusPhone: string = null;
	cusTaxCode: string = null;
	cusEmail: string = null;
	cusIdentityNo: string = null;
	cusBankName: string = null;
	cusBankNo: string = null;
	currencyUnit: string = null;
	exchangeRate: number = null;
	convertedAmount: number = null;
	paymentMethod: string = null;
	comCode: string = null;
	comName: string = null;
	comAddress: string = null;
	comTaxCode: string = null;
	comEmail: string = null;
	comPhone: string = null;
	comBankName: string = null;
	comBankNo: string = null;
	grossValue8: number = null;
	discount8: number = null;
	serviceCharge8: number = null;
	vatAmount8: number = null;
	totalAmount8: number = null;
	grossValue10: number = null;
	discount10: number = null;
	serviceCharge10: number = null;
	vatAmount10: number = null;
	totalAmount10: number = null;
	total: number = null;
	amountVat: number = null;
	discountAmount: number = null;
	totalAmount: number = null;
	amountInWords: string = null;
	publishInvoiceStatus: string = null;
	publishInvoiceRespone: string = null;
	sendInvoiceStatus: string = null;
	sendInvoiceRespone: string = null;
	taxAuthorityCode: string = null;
	invoicePdfDownload: string = null;
	invoiceXmlDownload: string = null;
	sendMailStatus: string = null;
	sendMailRespone: string = null;
	batchNoCusStatus: string = null;
	invoiceAutoNumber: string = null;
	signDate: string = null;
	invoiceStatus: string = null;
	invoiceStatusResponse: string = null;
	fkeyCancel: string = null;
	invoiceNumberCancel: string = null;
	discountAmount8: number = null;
	discountAmount10: number = null;
	totalVat8: number = null;
	totalVat10: number = null;
	ticketType: string = null;
	ticketInvoiceItems: TicketInvoiceItem[] = [];
}

export class RestaurantConfig {
	restaurantName: string = "";
	taxID: string = "";
	address: string = "";
	searchInvoice: string = "";
}

export class TicketInvoiceItem {
	ticketId: string = null;
	rowNo: number = null;
	isSum: string = null;
	prodCode: string = null;
	prodName: string = null;
	prodUnit: string = null;
	prodQuantity: number = null;
	prodPrice: number = null;
	total: number = null;
	discountRate: number = null;
	discountAmount: number = null;
	vatRate: number = null;
	vatAmount: number = null;
	amount: number = null;
	itemOrder: number = null;
}

export class TicketInvoiceListResponse {
	tickets: TicketInvoiceResponse[] = [];
}

export class TicketInvoiceResponse {
	ticketId: number = null;
	publishInvoiceStatus: string = null;
	publishInvoiceResponse: string = null;
	sendInvoiceStatus: string = null;
	sendInvoiceRespone: string = null;
	taxAuthorityCode: string = null;
	invoicePdfDownload: string = null;
	invoiceXmlDownload: string = null;
	sendMailStatus: string = null;
	sendMailRespone: string = null;
	batchNoCusStatus: string = null;
}

export class CompanyInfoResponse {
	id: string = null;
	name: string = null;
	name_F: string = null;
	short_Name: string = null;
	enterprise_Code: string = null;
	enterprise_Gdt_Code: string = null;
	status: string = null;
	city_Id: string = null;
	district_Id: string = null;
	ward_Id: string = null;
	ho_Address: string = null;
	ho_Address_F: string = null;
	legal_First_Name: string = null;
}

export class UpdateTicketTotalRequest {
	ticketId: number;
	totalVat8: number;
	totalVat10: number;
	discountVat8: number;
	discountVat10: number;
	serviceChargeVat8: number;
	serviceChargeVat10: number;
	vat8: number;
	vat10: number;
	netAmount8: number;
	netAmount10: number;
	subTotal: number;
	totalDiscount: number;
	serviceCharge: number;
	totalTax: number;
	totalPrice: number;
}

export class TicketTotal {
	ticketId: number;
	totalVat8: number;
	totalVat10: number;
	discountVat8: number;
	discountVat10: number;
	serviceChargeVat8: number;
	serviceChargeVat10: number;
	vat8: number;
	vat10: number;
	netAmount8: number;
	netAmount10: number;
	subTotal: number;
	totalDiscount: number;
	serviceCharge: number;
	totalTax: number;
	totalPrice: number;
	paidAmount: number;
}
